import { Component, Inject } from "@angular/core";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { DateUtil, GetTimelineGraphPoints, TimelineItem, TimelineData, TimelineStateModel, TimelineGraphPoint, GraphPointResponse, NetworkMember, Time, ScoredSubscription } from 'huddyapi';
import { max } from "moment";
import { Observable, Subscription } from "rxjs";

import moment_ from 'moment';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

const moment = moment_;

@Component({
  selector: 'graph-detail',
  templateUrl: 'graph-detail.html',
  styleUrls: ["./graph-detail.component.scss"]
})
export class GraphDetail  {
  
  static loadingSize : number = 8;
  item : TimelineItem;
  itemList : TimelineItem[] = [];
  itemData : TimelineData[];
  startDay : number;
  endDay : number;
  patientName : string;
  patientId : number;
  @Select(state => state.timelineState) timelineState$: Observable<TimelineStateModel>;
  timelineSubscription : Subscription;
  graphPointMap : Map<number, TimelineGraphPoint[]>;
  statistics : Map<number, ItemStatistics> = new Map();
  loading : boolean;
  loadingIndex : number = 0;
  scoredSubscriptions : ScoredSubscription[];

  // options
  multi: Map<number, any>;
  symptomGroups : Map<number, SymptomGroup>;

  // options

  backgroundColorPlugin = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart, args, options) => {
      const {ctx} = chart;
      ctx.save();
      const grd = ctx.createLinearGradient(0, 0, 0, chart.height);
      grd.addColorStop(0, '#F76C9333');
      grd.addColorStop(1, ' #F76C93AA');
      ctx.globalCompositeOperation = 'destination-over';
      ctx.fillStyle = grd; //options.color || '#FFC8E0';
      ctx.fillRect(0, 0, chart.width, chart.height);
      ctx.restore();
    }
  };

  fillerPlugin = {
    filler: {
      propagate: true
    }
  }

  legendOption = {
    display: false
  };

  plugins : any[] = [this.backgroundColorPlugin, this.fillerPlugin];
  xAxisLabel: string = 'Date';
  yAxisLabel: string = 'Value';
  timeline: boolean = true;
  

  colorScheme = {
    domain: ['#00FF00', '#FF0000', '#000000' ]
  };
  type = 'scatter';
  options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: this.legendOption,
    scales: {
      xAxes: [{
          gridLines: {
            color: 'white'
          },
          ticks: {
              userCallback: function(label, index, labels) {
                  return moment.unix(label).format("MM/YY");
              },
              fontColor: 'white' 
           }
      }],
      yAxes: [ {
          gridLines: {
            color: 'white'
          },
          ticks: {
            userCallback: function(label, index, labels) {
              return Math.round(label * 100) / 100;
          },
            fontColor: 'white'
          }
      }]
    },
    animation: false,
    tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
                var label = tooltipItem.xLabel || '';

                if (label) {
                    label = moment.unix(label).format("MM/DD/YY hh:mm")
                    label += ': ';
                }
                label += Math.round(tooltipItem.yLabel * 100) / 100;
                return label;
            }
        }, 
        intersect: false
    },
    layout: {
      padding: {
          left: 10,
          right: 10,
          top: 20,
          bottom: 10
      }
  }
  }; 

  stackedOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend:{
      display: true,
      position: 'bottom',
      alignment: 'left'
    },
    scales: {
      xAxes: [{
          gridLines: {
            color: 'white'
          },
          ticks: {
              userCallback: function(label, index, labels) {
                  return moment.unix(label).format("MM/YY");
              },
              fontColor: 'white' 
           }
      }],
      yAxes: [ {
          stacked: true,
          gridLines: {
            color: 'white'
          },
          ticks: {
            userCallback: function(label, index, labels) {
              return Math.round(label * 100) / 100;
          },
            fontColor: 'white'
          }
      }]
    },
    animation: false,
    tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
                var label = tooltipItem.xLabel || '';

                if (label) {
                    label = moment.unix(label).format("MM/DD/YY hh:mm")
                    label += ': ';
                }
                label += Math.round(tooltipItem.yLabel * 100) / 100;
                return label;
            },
            title: function(tooltipItem, data) {
              let title =  tooltipItem.label;
              return title;
            }
        },
        intersect: false

    },
    layout: {
      padding: {
          left: 10,
          right: 10,
          top: 20,
          bottom: 10
      }
  }
  }; 

  dateFormat : string = 'MM-DD-YYTHH:mm:ss.SSS';

  graphPoints : any[];

  constructor(
    public dialogRef: MatDialogRef<GraphDetail>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public store : Store
  )
  {
    this.patientName = data.patientName;
    this.item = data.dataItem;
    this.itemData = data.data;
    this.itemList = data.items;
    this.startDay = data.min;
    this.endDay = data.max;
    this.scoredSubscriptions = data.scoredSubscriptions;
    console.log('Index', this.item);
    if (this.item) {
      const idx : number = this.itemList.findIndex(item => item.id === this.item.id);
      console.log('Index', idx);
      if (idx > 0) {
        moveItemInArray(this.itemList, idx, 0);
      }
    }
    this.graphPointMap = new Map();
    this.patientId = data.patientId;
    console.log('graph detail', this.item, this.itemData, this.itemList);
    // if (this.item.units) {
    //   this.yAxisLabel = this.item.units;
    // }
    this.  timelineSubscription  = this.timelineState$.subscribe((ts: TimelineStateModel) => {
      
      if (ts && ts.graphPointResponse && this.itemList) {
         this.multi = new Map();
         this.symptomGroups = new Map();
         const  graphResponse : GraphPointResponse = ts.graphPointResponse;
         //console.log('Timeline state: ',ts, graphResponse.graphPoints);   

         let min : number =   this.startDay;
         let max : number = this.endDay;
         let dates : number[] = [];
         for (let epochDay = min; epochDay <= max; epochDay++)
         {
           let t : Time =  DateUtil.fromEpochDay(epochDay);
           let n = t.momentVal;
           dates.push( n.unix());
         }

         
         
         Object.keys(graphResponse.graphPoints).forEach(k => {
          const v : TimelineGraphPoint[] = graphResponse.graphPoints[k];
          // console.log('Graph points', k, v);
          this.graphPointMap.set(+k, v);
         });
        console.log('graphPointMap', this.graphPointMap);


        this.graphPointMap.forEach((v, k) => {
          if (v) {
            let id : number = k;
            let itemIdx : number = this.itemList.findIndex(item => item.id === id);
            if (itemIdx > -1) {
              let points : Point[] = v.map((p: TimelineGraphPoint) =>
              {
                let dateStr = p.dateTime.toString();
                let idx = dateStr.indexOf('.');
                if (idx > -1)
                  dateStr = dateStr.substring(0, idx);

                let t : Time = new Time(dateStr);
                let n = t.momentVal.unix();
                if (this.itemList[itemIdx].type === 'SYMPTOM' ) {
                  console.log('Timeline converted dates: ', p.dateTime.toString(), dateStr, t.momentVal.toString(), n);
                }
                let gp : Point = {
                  x: n,
                  y: p.value
                };
                return gp;
              });
              console.log ('Timeline converted:', points);
              let item : TimelineItem = this.itemList[itemIdx];
              if (item.type === 'SYMPTOM') {
                this.buildSymptomGroups(dates, points, item);
              } else {
                this.buildGraphable(dates, points, item);
              }
              

              // console.log('Results', k, this.multi.get(k));
            }
          }
        });
        this.loading = false;
        this.requestMoreItems();
        console.log("symptom groups", this.symptomGroups);
      }
    });
    this.requestMoreItems();

  }

  ngOnInit(): void {

  }

  getSymptomGroupsKeys() {
    return this.symptomGroups.keys();
  }

  buildSymptomGroups(dates : number[], points : Point[], item : TimelineItem) {
    console.log('Entering buildSymptomGroups', this.scoredSubscriptions, item);
    
    let data : number[] = [];
    for (let i = 0; i < dates.length; i++) {
      let n : number = NaN;
      if (i+1 < dates.length ) {
        const next : number = dates[i+1];
        const pValue : Point = points.find(p => p.x > dates[i] && p.x <= next);
        if (pValue) {
          n = pValue.y;
        } 
        data.push(n);
      }
    }
    const compassId : number = item.compassControlId;
    const scoredSubscription : ScoredSubscription = this.scoredSubscriptions.find(s => s.trackables.map(t => t.name).indexOf(item.name) > -1);
    const color = NetworkMember.getColorForName(item.name);
    const dataset = {
      type: 'line',
      label: item.name,
      data: data,
      borderWidth: 1,
      pointRadius: 1,
      fill: true,
      spanGaps: true
    };
    if (this.symptomGroups.has(compassId)) {
      let symptomGroup = this.symptomGroups.get(compassId);
      symptomGroup.items.push(item);
      //dataset['fill'] = symptomGroup.chartsJsData.datasets.length + 1;
      dataset['backgroundColor'] = GraphDetail.FILL_COLORS[ symptomGroup.chartsJsData.datasets.length];
      symptomGroup.chartsJsData.datasets.push(dataset);
      this.symptomGroups.set(compassId, symptomGroup);
    } else {
      let chartJsData =  {
        datasets: [ ],
        labels: dates
      };
      let symptomGroup =  {
        items : [item],
        compassId : compassId,
        compassName : scoredSubscription.compassName,
        chartsJsData : chartJsData
      };
      //dataset['fill'] = symptomGroup.chartsJsData.datasets.length + 1;
      dataset['backgroundColor'] = 'red';
      symptomGroup.chartsJsData.datasets.push(dataset);
      this.symptomGroups.set(compassId, symptomGroup);
    }

  }

  getSymptomData(key : number) {
    return this.symptomGroups.get(key).chartsJsData;
  }

  buildGraphable(dates : number[], points : Point[], item : TimelineItem) {
    let filled : Point[] = this.buildFilled(dates, points);
    console.log ('Timeline filled:', filled);
    let squareFitter = new GraphDetail.squareFitter();
    let trendline : Point[] = squareFitter.squareProject(filled);
    console.log('Timeline trendline' , trendline);

    let values : number[] = points.map(gp => +gp.y);
    let count = values.length;
    let average = values.reduce((a, b) => a + b, 0) / values.length;
    let maximum = Math.max(...values);
    let minimum = Math.min(...values);
  
    this.statistics.set(item.id, {
      count: count,
      average : average,
      maximum: maximum,
      minimum : minimum
    });

    const trendlineColor : string = count > 1 ? '#AAA' : 'rgb(0,0,0,0)';

    let chartJsData =  {
        datasets: [
        {
            type: 'scatter',
            label: item.name,
            data: points,
            borderWidth: 1,
            pointRadius: 2,
            backgroundColor: 'white',
            pointBorderColor: 'white',
        },
        {
          type: 'line',
          label: 'Trend',
          data: trendline,
          backgroundColor: 'rgba(0,0,0,0)',
          borderColor: trendlineColor,
          pointRadius: .5,
          border: 0
        }
      ],
        labels: dates
    };
    this.multi.set(item.id, chartJsData);
  }

  requestMoreItems() {
    if (this.itemList && this.loadingIndex < this.itemList.length) {
        if (this.loadingIndex === 0) {
          this.loading = true;
        }
        const itemIds : string = this.itemList.slice(this.loadingIndex, this.loadingIndex + GraphDetail.loadingSize)
          .map(item => item.id).join(',');
        this.loadingIndex += GraphDetail.loadingSize;
        this.store.dispatch(new GetTimelineGraphPoints(undefined, itemIds));
    }
  }

  dropItem(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.itemList, event.previousIndex, event.currentIndex);
  }

  getResults(item : TimelineItem) : any[] {
    if (this.multi.has(item.id)) {
      //console.log('getResults', item, this.multi.get(item.id));
      return this.multi.get(item.id);
    }
    return [];
  }

  getGraphableItems() : TimelineItem[] {
    return this.itemList.filter(item => this.graphPointMap.has(item.id) && item.type != 'SYMPTOM');
  }
 
  reset() {
    this.item = undefined;
    this.itemList  = [];
    this.itemData = undefined;
    this.patientId = undefined;
    this.graphPointMap.clear();
    this.graphPointMap  = undefined;
    this.statistics = new Map();
    this.loading = false;
    this.multi.clear();
    this.multi = undefined;    
    this.timelineSubscription.unsubscribe();
  }
  
  close() {
      this.reset()
      this.dialogRef.close();
  }
  static squareFitter = class SquareFitter
  {
      count : number = 0;
      sumX : number = 0;
      sumX2 : number = 0;
      sumX3 : number = 0;
      sumX4 : number = 0;
      sumY : number = 0;
      sumXY : number = 0;
      sumX2Y : number = 0;
  
      constructor() {
  
      }
  
      add(x : number, y : number)
      {
          this.count++;
          this.sumX += x;
          this.sumX2 += x*x;
          this.sumX3 += x*x*x;
          this.sumX4 += x*x*x*x;
          this.sumY += y;
          this.sumXY += x*y;
          this.sumX2Y += x*x*y;
      }
  
      project(x : number)
      {
          var det : number = this.count*this.sumX2*this.sumX4 - this.count*this.sumX3*this.sumX3 - this.sumX*this.sumX*this.sumX4 + 2*this.sumX*this.sumX2*this.sumX3 - this.sumX2*this.sumX2*this.sumX2;
  
          var offset : number = this.sumX*this.sumX2Y*this.sumX3 - this.sumX*this.sumX4*this.sumXY - this.sumX2*this.sumX2*this.sumX2Y + this.sumX2*this.sumX3*this.sumXY + this.sumX2*this.sumX4*this.sumY - this.sumX3*this.sumX3*this.sumY;
          
          var scale : number = -this.count*this.sumX2Y*this.sumX3 + this.count*this.sumX4*this.sumXY + this.sumX*this.sumX2*this.sumX2Y - this.sumX*this.sumX4*this.sumY - this.sumX2*this.sumX2*this.sumXY + this.sumX2*this.sumX3*this.sumY;
  
          var accel : number = this.sumY*this.sumX*this.sumX3 - this.sumY*this.sumX2*this.sumX2 - this.sumXY*this.count*this.sumX3 + this.sumXY*this.sumX2*this.sumX - this.sumX2Y*this.sumX*this.sumX + this.sumX2Y*this.count*this.sumX2;
  
          return (offset + x*scale + x*x*accel)/det;
      }
  
  
    squareProject(points : Point[]) : Point[]
    {
        //console.log('Timeline squareProject', points);
        for (var i = 0; i < points.length; i++)
        {
            this.add(i, points[i].y);
        }
        let ret : Point[] = [];
        for (var i = 0; i < points.length; i++)
        {
            ret.push({ x: points[i].x, y: this.project(i) });
        }
        return ret;
    }
  }


  buildFilled(dates: number[], points: Point[]): Point[] {
    //console.log('Timeline dates', dates);
    return dates.map(date => {
      let m1 = moment.unix(date);
      let values: number[] = points.filter(p => moment.unix(p.x).isSame(m1, 'day')).map(p => p.y);
      let y : number = 0;
      if (values.length === 0) {
        let latest : number[] = points.map(p => p.x).filter(x => x < date);
     
        let last : number = points[0].x;
        if (latest.length > 0) {
          last = Math.max(...latest);
        } 
       
        let m2 = moment.unix(last);
        let lastValues : number[] = points.filter(p => moment.unix(p.x).isSame(m2, 'day')).map(p => p.y);
        let earliest : number[] = points.map(p => p.x).filter(x => x > date);
        let next : number = points[points.length - 1].x;
        if (earliest.length > 0) {
          next  = Math.min(...earliest);
        } 
        let m3 = moment.unix(next);
        let nextValues : number[] = points.filter(p => moment.unix(p.x).isSame(m3, 'day')).map(p => p.y);
        //console.log('numerator', m1.diff(m2), 'denominator', m3.diff(m2));
        let fraction : number = (m1.diff(m2, 'days') / (m3.diff(m2, 'days')));
        if (isNaN(fraction) || !isFinite(fraction)) {
          fraction = 0;
        }
        let lastValuesAvg : number = this.average(lastValues);
        let nextValuesAvg : number = this.average(nextValues);
        if (isNaN(nextValuesAvg)) {
          nextValuesAvg = lastValuesAvg;
        }
        y = lastValuesAvg + (fraction * (nextValuesAvg - lastValuesAvg)); 
        //  if (date === 1610859600) {
        //   console.log('Timeline', date, fraction, nextValuesAvg, lastValuesAvg, y);
        //   //date, latest, last, lastValues, earliest, next, nextValues, m1.diff(m2, 'days'), m3.diff(m2, 'days'), fraction, this.average(nextValues), this.average(lastValues), y);
        // }
      } else {
        y = this.average(values);
      }
      return { x: date, y: y};
    })
  }

  getLoadedSize() : number {
    return this.symptomGroups.size + this.multi.size;
  }

  average(n : number[]) : number {
    const sum = n.reduce((a, b) => a + b, 0);
   return (sum / n.length) || 0;
  }

  static FILL_COLORS : string[] = ['#b52033', '#172d4d', '#94d74a', '#f6bf63', '#5d5e58', '#de72b3', '#36446a', '#aa823e', '#fcd8b0', '#281e3f', '#15513e', '#2c2977', '#a5494c', '#161b22', '#d7d5fd', '#4b4948', '#2f3031', '#42bf67', '#c8ccb9', '#526e9d', '#663c23', '#a39ad3', '#e4c28d', '#70a246', '#3d2219', '#522c78', '#a05d3e', '#227b41', '#e8a283', '#409ecc', '#756e65', '#b63d80', '#f1824b', '#ce8c86', '#a8625c', '#f8bbb2', '#83897a', '#dc443e', '#7a2e27', '#851f2b', '#b7b5c5', '#5e154b', '#da886f', '#fece36', '#243397', '#94bed1', '#54e7e7', '#a6a69b', '#4d3d3d', '#2f60c4', '#f8e770', '#e0a4fb', '#363943', '#ffe6f8', '#f3ffef', '#79f7be', '#dabb55', '#3e9339', '#815c46', '#010f0c', '#cee758', '#c09871', '#273a33', '#8b46ba'];
}

interface ItemStatistics {
  average : number;
  count : number;
  maximum : number;
  minimum : number;
}

interface Point {
  x : number;
  y : number;
}

interface SymptomGroup {
  items : TimelineItem[];
  compassId : number;
  compassName : string;
  chartsJsData : any;

}



